import { render, staticRenderFns } from "./OnboardingInstallationLimitModal.vue?vue&type=template&id=844fb9d2&scoped=true"
import script from "./OnboardingInstallationLimitModal.vue?vue&type=script&lang=js"
export * from "./OnboardingInstallationLimitModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingInstallationLimitModal.vue?vue&type=style&index=0&id=844fb9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844fb9d2",
  null
  
)

export default component.exports